<template>
  <div class="loader"/>
</template>

<script>
export default {
  name: 'loader'
}
</script>
